module.exports = __webpack_public_path__ + "img/loading_logo.8afab59f.png";